/*
 * Fila de tarjetas KPI del dashboard, con tipografía y tokens del codekit
 */
import { Box, Description, Flexbox, Heading, Stack } from "codekit";

/**
 * Renderiza una tarjeta KPI individual
 * @param {Object} props Propiedades de la tarjeta
 * @param {string} props.label Etiqueta superior
 * @param {string} props.value Valor principal
 * @param {string} props.delta Texto secundario opcional
 */
const KpiCard = ({ label, value, delta }) => (
  <Box bg="secondary-100" rounded="lg" spacing={5} style={{ flex: 1, minWidth: 220 }}>
    <Stack gap={2}>
      <Description variant="description-3" color="secondary-700">
        {label}
      </Description>
      <Heading variant="heading-5" color="secondary-800">
        {value}
      </Heading>
      {delta ? (
        <Description variant="description-3" color="neutral-500">
          {delta}
        </Description>
      ) : null}
    </Stack>
  </Box>
);

/**
 * Renderiza la fila de tarjetas KPI
 * @param {Object} props Propiedades del componente
 * @param {Array} props.kpis Lista de KPIs [{ label, value, delta }]
 */
const Kpicards = ({ kpis = [] }) => (
  <Flexbox gap={4} wrap>
    {kpis.map((mKpi, nIndex) => (
      <KpiCard key={nIndex} label={mKpi.label} value={mKpi.value} delta={mKpi.delta} />
    ))}
  </Flexbox>
);

export default Kpicards;
